<template>
  <ts-card>
    <div
      class="
        form-header
        ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative
      "
    >
      <h4 class="ts-text-sm ts-uppercase ts-font-bold">
        {{ $t('school.academic.setup.program.grade.academicCoreProgramTitle') }}
      </h4>
      <ts-modal-close-button />
    </div>
    <div style="height: 50vh" class="ts-overflow-auto">
      <table class="ts-w-full ts-mb-5">
        <thead>
          <tr class="ts-uppercase ts-bg-gray-200 ts-h-10 ts-sticky ts-top-0">
            <th class="ts-whitespace-no-wrap ts-pl-2" style="width: 45%">
              {{
                $t(
                  'school.academic.setup.program.grade.academicCoreProgramNameEN'
                )
              }}
            </th>
            <th class="ts-whitespace-no-wrap" style="width: 45%">
              {{
                $t(
                  'school.academic.setup.program.grade.academicCoreProgramNameKH'
                )
              }}
            </th>
            <th style="width: 10%"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="ts-cursor-pointer hover:ts-bg-gray-300 ts-w-full ts-h-10"
            v-for="(core, index) in corePrograms"
            :key="index"
          >
            <td class="ts-whitespace-no-wrap ts-text-left ts-pl-2">
              {{ core.core_program_en }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-left">
              {{ core.core_program_kh }}
            </td>
            <td class="ts-whitespace-no-wrap text-primary ts-text-center">
              <a href="#" v-tooltip="$t('add')" @click.prevent="add(core)">
                <i class="fas fa-plus"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ts-card>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { includes } from 'lodash'

export default {
  name: 'create',
  props: ['value'],
  data () {
    return {
      model: {},
      sending: false,
      errors: new Errors(),
      coreProgramList: []
    }
  },
  created () {
    this.model = this.value
  },
  computed: {
    ...mapState('grade', ['core_programs']),
    corePrograms () {
      return this.core_programs.filter(
        c =>
          !includes(
            this.model.core_pro_list.map(d => d.core_pro_id),
            c.core_pro_id
          )
      )
    }
  },
  methods: {
    clear () {
      this.model = {}
    },
    add (core) {
      this.model.core_pro_list.push({
        core_pro_id: core.core_pro_id,
        core_program_en: core.core_program_en,
        core_program_kh: core.core_program_kh
      })

      var index = this.core_programs.indexOf(
        this.core_programs.find(e => e.core_pro_id == core.core_pro_id)
      )
      this.core_programs.splice(index, 1)
    }
  },
  watch: {}
}
</script>
